import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaHeart, FaInstagram, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer style={{
            backgroundColor: 'var(--deep-green)',
            color: 'var(--warm-cream)',
            marginTop: 'auto',
            borderTop: '4px solid var(--primary-gold)',
            fontFamily: 'Inter, sans-serif'
        }}>
            <Container className="pt-5 pb-4">
                <Row className="gy-4">
                    {/* Brand Column */}
                    <Col lg={5} md={6} className="mb-4 mb-lg-0">
                        <Link to="/" className="text-decoration-none">
                            <h3 style={{
                                fontFamily: 'Playfair Display',
                                fontWeight: '700',
                                color: 'var(--primary-gold)',
                                fontSize: '2rem',
                                marginBottom: '0.5rem'
                            }}>
                                FruValley
                            </h3>
                        </Link>
                        <p className="small opacity-75 mb-3" style={{ fontSize: '0.9rem', maxWidth: '350px', lineHeight: '1.6' }}>
                            Empowering Kashmir's trade and new businesses. Connect, trade, and grow with FruValley.
                        </p>
                        <div className="d-flex align-items-center gap-3">
                            <a
                                href="https://instagram.com/fruvalley.kashmir"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-white hover-gold transition-all"
                            >
                                <FaInstagram size={24} />
                            </a>
                        </div>
                    </Col>

                    {/* Quick Links */}
                    <Col lg={3} md={6} xs={12}>
                        <h5 className="mb-3" style={{ fontFamily: 'Playfair Display', color: 'var(--primary-gold)' }}>Discover</h5>
                        <ul className="list-unstyled">
                            <li className="mb-2">
                                <Link to="/shop" className="text-white-50 text-decoration-none hover-gold transition-all">Shop Authentic</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/location" className="text-white-50 text-decoration-none hover-gold transition-all">Locations</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/founder" className="text-white-50 text-decoration-none hover-gold transition-all">Founder</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/blog" className="text-white-50 text-decoration-none hover-gold transition-all">Stories of Kashmir</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/about" className="text-white-50 text-decoration-none hover-gold transition-all">About Us</Link>
                            </li>
                        </ul>
                    </Col>

                    {/* Contact / Help */}
                    <Col lg={4} md={6} xs={12}>
                        <h5 className="mb-3" style={{ fontFamily: 'Playfair Display', color: 'var(--primary-gold)' }}>Contact</h5>
                        <ul className="list-unstyled">
                            <li className="mb-2 d-flex align-items-start gap-2 text-white-50">
                                <FaMapMarkerAlt className="mt-1 flex-shrink-0" size={14} color="var(--primary-gold)" />
                                <span>Verinag, Anantnag, Kashmir, J&K</span>
                            </li>
                            <li className="mb-2 d-flex align-items-center gap-2 text-white-50">
                                <FaEnvelope size={14} color="var(--primary-gold)" />
                                <a href="mailto:fruvalley.kashmir@gmail.com" className="text-white-50 text-decoration-none hover-gold text-break">fruvalley.kashmir@gmail.com</a>
                            </li>
                        </ul>
                    </Col>
                </Row>

                <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '2rem 0' }} />

                <Row className="align-items-center">
                    <Col md={6} className="text-center text-md-start mb-2 mb-md-0">
                        <p className="mb-0 small text-white-50">
                            &copy; {new Date().getFullYear()} FruValley. All rights reserved.
                            <br className="d-md-none" />
                            <span className="d-none d-md-inline mx-2">|</span>
                            <Link to="/privacy" className="text-white-50 text-decoration-none small hover-gold">Privacy Policy</Link>
                            <span className="mx-2">|</span>
                            <Link to="/terms" className="text-white-50 text-decoration-none small hover-gold">Terms</Link>
                        </p>
                    </Col>
                    <Col md={6} className="text-center text-md-end">
                        <p className="mb-0 small text-white-50">
                            Crafted with <FaHeart className="text-danger mx-1" size={12} /> in the Valley
                        </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;